/**
 * TanStack Query hooks for `performance-report-per-publisher`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	performanceReportPerPublisherQueryKeys,
	type CreatePerformanceReportPerPublisherBody,
	type ListPerformanceReportPerPublisherResponse,
	type PerformanceReportPerPublisherRow,
} from "./api";

export function usePerformanceReportPerPublisherList(): UseQueryResult<ListPerformanceReportPerPublisherResponse, Error> {
	return useQuery({
		queryKey: performanceReportPerPublisherQueryKeys.list(),
		queryFn: list,
	});
}

export function usePerformanceReportPerPublisherCreate(): UseMutationResult<PerformanceReportPerPublisherRow, Error, CreatePerformanceReportPerPublisherBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: performanceReportPerPublisherQueryKeys.all });
		},
	});
}

export function usePerformanceReportPerPublisherDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: performanceReportPerPublisherQueryKeys.all });
		},
	});
}
